<template>

	<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
		<h4>Voormeldingen</h4>

		<c-table
			:columns="columns"
			:testRows="testRows"
			:search="false">
		</c-table>
        <div class="c-prenotification__button" @click="trigger('new-prenotification')">
			<button class="c-btn c-btn--hollow no-margin">
				+ Toevoegen
			</button>
		</div>
	</div>

</template>

<script>
import CTable from '@components/table/Table';

export default {
	components: { CTable },
	props: {
		testRows: {
			required: true,
			type: Array,
		},
	},

    methods: {
        trigger(event) {
           this.$store.dispatch('listener/emit', event);
		}
    },
	computed: {
		columns() {
			let columns = [
				{ name: 'reference', label: 'Ordernummer', sortable: true, sort: true },
				{ name: 'products.*.name', label: 'Artikelomschrijving', sortable: true },
				{ name: 'products.*.article_number', label: 'Artikelnummer', sortable: true },
				{ name: 'products.*.quantity.expected', label: 'Voorgemeld', sortable: true },
				{ name: 'products.*.quantity.arrived', label: 'Geleverd', sortable: true },
                { name: 'expected', label: 'Leverdatum', sortable: true },
                //{ name: 'products.*.items.*.status.name', label: 'Status', sortable: true },
			];

			return columns;
		},

		rows(){
			let rows = [
					//	{ Ordernummer: '1234 5678', Artikelomschrijving: "HP Probook 450 GB", Artikelnummer: "123456789", Voorgemeld: "30", Geleverd: "16", Leverdatum: "3 april 2022", Status: "Aangemaakt"},
					]



			return rows;
		},
	}
}
</script>
